import { Controller } from 'stimulus'
import { cart_pt_br_path } from "routes";
import { doDelete, doPut, viewportName } from "../../packs/utils";


export default class extends Controller {
  initialize() {
    this.viewPort = viewportName()
    this.amount = this.getTarget('amount').value;
  }

  static get targets() {
    return ['remove', 'update', 'amount', 'loader'];
  }

  getTarget(attrName) {
    const attrs = this[`${attrName}Targets`]
    return this.viewPort === 'computer' ? attrs[0] : attrs[1]
  }

  getFirstTarget(attrName) {
    return this[`${attrName}Targets`]
  }

  remove(e) {
    let data = new FormData()
    data.append('item_uuid', this.getTarget('remove').getAttribute('data-item-uuid'))

    this.loaderTarget?.classList.add('active')

    doDelete(cart_pt_br_path(), data, (res) => {
      window.location.reload()
    })
  }

  validate(e) {
    const intAmount = parseInt(String(this.getTarget('amount').value).replaceAll('.', ''))
    const intLot = parseInt(this.getTarget('amount')?.getAttribute('data-lot'))
    const intStock = parseInt(this.getTarget('amount')?.getAttribute('data-stock'))
    const stock_type = this.getTarget('amount')?.getAttribute('data-stock-type')
    const metric = this.getTarget('amount')?.getAttribute('data-metric')


     /* ensure that the amount is multiple of lot */
    if (intLot && (intAmount % intLot !== 0)) {
      this.getTarget('amount').value = intLot
      alert(`Este item é vendido apenas em lotes de ${intLot} ${metric}. Por favor insira um múltiplo desse valor.`)
      return
    }

    /* Check stock type */
    if (stock_type === "limited" ){
      if (intStock < intAmount){ /* ensure that the amount is lesser of stock */
        alert(`O valor inserido não pode ser maior que ${intStock} ${metric}.`)
        this.getTarget('amount').value = intStock
        return
      }
    }

    /* max quantity, biggest multiple of the lot that fits in 52k */
    const maxQuantity = parseInt(52000 / intLot) * intLot

    /* return if amount is lesser than 1 */
    if (intAmount < 1) {
      this.getTarget('amount').value = intLot
    } else if (intAmount > maxQuantity) { /* return biggest multiple of the lot that fits in 52k */
        alert(`A quantidade máxima permitida para esta operação é de: ${maxQuantity.toLocaleString()} ${metric}.`)
        this.getTarget('amount').value = maxQuantity
    }
  }

  update(e){
    let data = new FormData()
    data.append('item_uuid', this.updateTarget.getAttribute('data-item-uuid'))
    data.append('value', parseInt(String(this.getTarget('amount').value).replaceAll('.', '')))
    data.append('field', 'amount')

    /* show the loader */
    this.loaderTarget?.classList.add('active')

    doPut(cart_pt_br_path(), data, (res) => {
      window.location.reload()
    })
  }

  amountInputChange(e) {
    let amount = parseInt(this.getTarget('amount').value)

    if (amount !== parseInt(this.amount)) {
      this.validate(e)
      this.update(e)
    }
  }
}
